import { RouteConfigName } from "src/config/routes";
import { Role } from "src/types";

export type PermissionParams = {
  role: Role;
  scopeList: string[];
  function: string;
}

export const GetPermissionMenu = (role: Role, route: RouteConfigName) => {

}